import { isPlainObject } from "@next-platform/packages-ts-types";
function readCanonicalPageBlockContentResponse(value) {
    if (!Array.isArray(value["items"]) || typeof value["total"] !== "number") {
        return null;
    }
    return { items: value["items"], total: value["total"] };
}
function readTypesensePageBlockContentResponse(value) {
    if (!Array.isArray(value["hits"]) || typeof value["found"] !== "number") {
        return null;
    }
    const documents = [];
    for (const hit of value["hits"]) {
        if (!isPlainObject(hit) || !isPlainObject(hit["document"])) {
            return null;
        }
        documents.push(hit["document"]);
    }
    return { items: documents, total: value["found"] };
}
/**
 * Normalizes a page block content body to `{ items, total }`. Accepts the
 * canonical contract and the Typesense search shape `{ hits, found }`.
 */
export default function readPageBlockContentResponse(value) {
    if (!isPlainObject(value)) {
        return null;
    }
    return readCanonicalPageBlockContentResponse(value) ?? readTypesensePageBlockContentResponse(value);
}
